module.exports = __webpack_public_path__ + "static/5K_Wallpaper_8-a2eabe7215fbe6be055f7f11b3766b6c.png";